import sso from './sso';

export default {
    namespaced: true,
    modules: {
        sso,
    },
    state: {
        menu: [
            { product: true, title: 'Admin', bgcolor: 'primary' },
            // { header: true, title: 'Main Navigation' },
            {
                title: 'Dashboard',
                icon: '/img/navicon/fbc-nav/Dashboard.svg',
                href: '/admin/dashboard'
            },
            // {
            //   title: 'Analysis', icon: 'mdi mdi-graphql', href: '/admin/monthly',
            // },
            { header: true, title: 'Manage', icon: '/img/navicon/UserPermissions.svg' },
            {
                title: 'Entities',
                icon: '',
                href: '/admin/client',
                right: "client"
            },
            {
                title: 'Users',
                icon: '',
                href: '/admin/user',
                right: "user"
            },
            { header: true, title: 'Manage Bots', icon: '/img/navicon/AutomationAgent.svg' },
            {
                title: 'Area Master',
                icon: '',
                href: '/admin/area',
                right: "conserve_area"
            },
            {
                title: 'Input Parameters',
                icon: '',
                href: '/admin/inputparameter',
                right: "conserve_input_parameter"
            },
            {
                title: 'File Master',
                icon: '',
                href: '/admin/file',
                right: "conserve_file"
            },
            {
                title: 'Verification',
                icon: '',
                href: '/admin/verification',
                right: "conserve_verification"
            },
            {
                title: 'Bots Master',
                icon: '',
                href: '/admin/bots',
                right: "conserve_bots"
            },
            { header: true, title: 'Permission', icon: '/img/navicon/Permission.svg' },
            {
                title: 'Rights',
                icon: '',
                href: '/admin/rights',
                right: "permission_right"
            },
            {
                title: 'Roles',
                icon: '',
                href: '/admin/roles',
                right: "permission_role"
            },
            { header: true, title: 'Subscription', icon: '/img/navicon/Apps.svg' },
            {
                title: 'Subscription Product',
                icon: '',
                href: '/admin/products',
                right: "conserve_bots"
            },
            {
                title: 'Subscription Plan',
                icon: '',
                href: '/admin/plans',
                right: "conserve_bots"
            },
            { header: true, title: 'Prompts Manager', icon: '/img/navicon/PromptSetting.svg', },
            {
                title: 'Prompts',
                icon: '',
                href: '/admin/prompts',
                right: "conserve_bots"
            },
        ],
        // Prompts state
        prompts: [],
        promptsLoading: false,
        promptsError: null,
        // Prompt list state (for /v2/ai/prompts/list API)
        promptsByType: {},
        promptListLoading: {},
        promptListError: null,
        // Input schema state (AiInputSchemaEditor)
        inputSchema: null,
        inputSchemaLoading: false,
        inputSchemaPreview: null,
        inputSchemaPreviewLoading: false,
    },
    mutations: {
        // Prompts mutations
        setPrompts(state, prompts) {
            state.prompts = prompts;
        },
        setPromptsLoading(state, loading) {
            state.promptsLoading = loading;
        },
        setPromptsError(state, error) {
            state.promptsError = error;
        },
        updatePromptInList(state, updatedPrompt) {
            // Find the feature that contains this prompt
            for (let feature of state.prompts) {
                if (feature.prompts) {
                    const promptIndex = feature.prompts.findIndex(p => p._id === updatedPrompt._id);
                    if (promptIndex !== -1) {
                        // Update the prompt in the feature
                        feature.prompts.splice(promptIndex, 1, updatedPrompt);
                        break;
                    }
                }
            }
        },
        addFeaturePrompt(state, { featureData, newPrompt }) {
            // Find existing feature or create new one
            let existingFeature = state.prompts.find(f => f.feature === featureData.feature);

            if (existingFeature) {
                // Add prompt to existing feature
                if (!existingFeature.prompts) {
                    existingFeature.prompts = [];
                }
                existingFeature.prompts.push(newPrompt);
            } else {
                // Create new feature with the prompt
                const newFeature = {
                    feature: featureData.feature,
                    name: featureData.name || featureData.feature,
                    prompts: [newPrompt]
                };
                state.prompts.push(newFeature);
            }
        },
        // Prompt list mutations
        setPromptsByType(state, { type, prompts }) {
            state.promptsByType = { ...state.promptsByType, [type]: prompts };
        },
        setPromptListLoading(state, { type, loading }) {
            state.promptListLoading = { ...state.promptListLoading, [type]: loading };
        },
        setPromptListError(state, error) {
            state.promptListError = error;
        },
        clearPromptsByType(state) {
            state.promptsByType = {};
            state.promptListLoading = {};
        },
        // Input schema mutations
        setInputSchema(state, schema) {
            state.inputSchema = schema;
        },
        setInputSchemaLoading(state, loading) {
            state.inputSchemaLoading = loading;
        },
        setInputSchemaPreview(state, preview) {
            state.inputSchemaPreview = preview;
        },
        setInputSchemaPreviewLoading(state, loading) {
            state.inputSchemaPreviewLoading = loading;
        },
        clearInputSchema(state) {
            state.inputSchema = null;
            state.inputSchemaPreview = null;
        }
    },
    actions: {
        // Fetch all available prompts from master
        async fetchPrompts({ commit }, axiosInstance) {
            commit('setPromptsLoading', true);
            commit('setPromptsError', null);

            try {
                const response = await axiosInstance.post('/v2/client/getAvailablePromptsFromMaster');

                if (response.data.status === 'success') {
                    commit('setPrompts', response.data.data);
                    return response.data.data;
                } else {
                    throw new Error(response.data.message);
                }
            } catch (error) {
                console.error('Error fetching prompts:', error);
                commit('setPromptsError', error.message || 'Unknown error!');
                throw error;
            } finally {
                commit('setPromptsLoading', false);
            }
        },

        // Update prompt by ID
        async updatePromptById({ commit }, { axiosInstance, promptData }) {
            try {
                const response = await axiosInstance.post(`/v2/client/updatePromptById/${promptData._id}`, {
                    data: promptData
                });

                if (response.data.status === 'success') {
                    // Update the prompt in the local state
                    commit('updatePromptInList', promptData);
                    return response.data;
                } else {
                    throw new Error(response.data.message || 'Error Updating Prompt');
                }
            } catch (error) {
                console.error('Error updating prompt:', error);
                throw error;
            }
        },

        // Create feature prompt
        async createFeaturePrompt({ commit }, { axiosInstance, featureData }) {
            try {
                const response = await axiosInstance.post('v2/client/prompts/create', {
                    data: featureData
                });

                if (response.data.status === 'success') {
                    // Add the new prompt to the local state
                    const newPrompt = {
                        _id: response.data.data?._id || Date.now().toString(),
                        type: featureData.type,
                        content: featureData.content,
                        name: featureData.name,
                        status: featureData.status
                    };

                    commit('addFeaturePrompt', { featureData, newPrompt });
                    return response.data;
                } else {
                    throw new Error(response.data.message || 'Error creating feature prompt');
                }
            } catch (error) {
                console.error('Error creating feature prompt:', error);
                throw error;
            }
        },

        // Fetch prompt list by feature and type
        async fetchPromptList({ commit }, { axiosInstance, feature, type }) {
            commit('setPromptListLoading', { type, loading: true });
            commit('setPromptListError', null);

            try {
                const data = { feature, type };
                const response = await axiosInstance.post('/v2/ai/prompts/list', data);

                if (response.data.status === 'success') {
                    const prompts = response.data.data || [];
                    commit('setPromptsByType', { type, prompts });
                    return prompts;
                } else {
                    throw new Error(response.data.message || 'Error fetching data');
                }
            } catch (error) {
                console.error('Error fetching prompt list:', error);
                commit('setPromptListError', error.message || 'Unknown error!');
                // Set empty array on error
                commit('setPromptsByType', { type, prompts: [] });
                throw error;
            } finally {
                commit('setPromptListLoading', { type, loading: false });
            }
        },

        // Initialize client AI features
        async initializeClientAIFeatures(context, { axiosInstance, clientId }) {
            try {
                const response = await axiosInstance.post(`/v2/client/initializeClientAIFeatures/${clientId}`);

                if (response.data.status === 'success') {
                    return response.data;
                } else {
                    throw new Error(response.data.message || 'Error initializing client AI features');
                }
            } catch (error) {
                console.error('Error initializing client AI features:', error);
                throw error;
            }
        },

        // Switch SOD (Start of Day) setting for client
        async switchSod(context, { axiosInstance, sodData }) {
            try {
                const response = await axiosInstance.post('/v2/client/switchSod', { data: sodData });

                if (response.data.status === 'success') {
                    return response.data;
                } else {
                    throw new Error(response.data.message || 'Error switching SOD setting');
                }
            } catch (error) {
                console.error('Error switching SOD setting:', error);
                throw error;
            }
        },

        // Update client details
        async updateClient(context, { axiosInstance, clientData, clientId }) {
            try {
                const response = await axiosInstance.post('/v2/client/edit', {
                    data: [clientData],
                    id: clientId
                });

                if (response.data.status === 'success') {
                    return response.data;
                } else {
                    // Handle validation errors
                    const error = new Error(response.data.message || 'Error updating client');
                    error.validationErrors = {};

                    if (response.data.data && response.data.data.length > 0) {
                        if (response.data.data[0].index0) {
                            error.validationErrors = response.data.data[0].index0;
                        }
                    }

                    throw error;
                }
            } catch (error) {
                console.error('Error updating client:', error);
                throw error;
            }
        },

        /**
         * Update user permission (super admin) setting for a client
         * @param {Object} context - Vuex context
         * @param {Object} payload - Contains axiosInstance, clientData, and clientId
         */
        async updateUserPermission({ commit }, { axiosInstance, clientData, clientId }) {
            try {
                const response = await axiosInstance.post(`/v2/client/edit/${clientId}`, {
                    data: [clientData]
                });

                if (response.data.status === 'success') {
                    const statusText = clientData.user_permissions_superadmin ? 'enabled' : 'disabled';
                    commit('sbSuccess', `User Permissions ${statusText} successfully!`, { root: true });
                    return { success: true };
                } else {
                    throw new Error(response.data.message || 'Error updating user permissions');
                }
            } catch (error) {
                console.error('[AdminStore] Error updating user permissions:', error);
                commit('sbError', error.message || error || 'Unknown error!', { root: true });
                throw error;
            }
        },

        // Input schema actions
        async fetchInputSchema({ commit }, { axiosInstance, feature }) {
            commit('setInputSchemaLoading', true);
            try {
                const response = await axiosInstance.post('/v2/ai/get-input-schema', { feature });
                if (response.data && response.data.status === 'success') {
                    commit('setInputSchema', response.data.data);
                    return response.data.data;
                } else {
                    commit('setInputSchema', null);
                    return null;
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    commit('setInputSchema', null);
                    return null;
                }
                console.error('Error fetching input schema:', error);
                throw error;
            } finally {
                commit('setInputSchemaLoading', false);
            }
        },

        async saveInputSchema({ commit }, { axiosInstance, feature, schema }) {
            try {
                const response = await axiosInstance.post('/v2/ai/create-input-schema', {
                    ...schema,
                    feature
                });
                if (response.data && response.data.status === 'success') {
                    const created = response.data.data?.[0] || response.data.data || schema;
                    commit('setInputSchema', created);
                    return created;
                } else {
                    throw new Error(response.data.message || 'Error creating input schema');
                }
            } catch (error) {
                console.error('Error creating input schema:', error);
                throw error;
            }
        },

        async updateInputSchema({ commit, state }, { axiosInstance, feature, schema }) {
            try {
                const response = await axiosInstance.post('/v2/ai/update-input-schema', {
                    ...schema,
                    feature
                });
                if (response.data && response.data.status === 'success') {
                    const fallback = { ...(state.inputSchema || {}), ...schema, version: (state.inputSchema?.version || 0) + 1 };
                    const updated = response.data.data?.[0] || response.data.data || fallback;
                    commit('setInputSchema', updated);
                    return updated;
                } else {
                    throw new Error(response.data.message || 'Error updating input schema');
                }
            } catch (error) {
                console.error('Error updating input schema:', error);
                throw error;
            }
        },

        async previewInputSchema({ commit }, { axiosInstance, payload }) {
            commit('setInputSchemaPreviewLoading', true);
            try {
                const response = await axiosInstance.post('/v2/ai/input-schema/preview', payload);
                const body = response.data || {};
                if (body.status === 'success' && body.data) {
                    commit('setInputSchemaPreview', body.data);
                    return body.data;
                }
                throw new Error(body.message || 'Error previewing input schema');
            } catch (error) {
                console.error('Error previewing input schema:', error);
                const msg = error.response?.data?.message || error.message || 'Error previewing input schema';
                throw new Error(msg);
            } finally {
                commit('setInputSchemaPreviewLoading', false);
            }
        },

        async testPrompt(_, { axiosInstance, payload }) {
            try {
                const response = await axiosInstance.post('/v2/ai/input-schema/test', payload);
                const body = response.data || {};
                if (body.status === 'success' && body.data) {
                    return body.data;
                }
                throw new Error(body.message || 'Error testing prompt');
            } catch (error) {
                console.error('Error testing prompt:', error);
                const msg = error.response?.data?.message || error.message || 'Error testing prompt';
                throw new Error(msg);
            }
        },

        async fetchCollections(_, { axiosInstance, clientId, clientCode }) {
            try {
                const payload = {};
                if (clientId) {
                    payload.client = clientId;
                    payload.client_id = clientId;
                }
                if (clientCode) {
                    payload.code = clientCode;
                    payload.client_code = clientCode;
                }
                const response = await axiosInstance.post('/v2/ai/get-collections', payload);
                if (response.data && response.data.status === 'success') {
                    return response.data.data || [];
                }
                throw new Error(response.data?.message || 'Error fetching collections');
            } catch (error) {
                console.error('Error fetching collections:', error);
                const msg = error.response?.data?.message || error.message || 'Error fetching collections';
                throw new Error(msg);
            }
        },

        async fetchCollectionFields(_, { axiosInstance, collection, clientId, clientCode }) {
            try {
                const payload = { collection };
                if (clientId) {
                    payload.client = clientId;
                    payload.client_id = clientId;
                }
                if (clientCode) {
                    payload.code = clientCode;
                    payload.client_code = clientCode;
                }
                const response = await axiosInstance.post('/v2/ai/get-collection-fields', payload);
                if (response.data && response.data.status === 'success') {
                    return response.data.data || [];
                }
                throw new Error(response.data?.message || 'Error fetching collection fields');
            } catch (error) {
                console.error('Error fetching collection fields:', error);
                const msg = error.response?.data?.message || error.message || 'Error fetching collection fields';
                throw new Error(msg);
            }
        },

        async fetchCollectionRefFields(_, { axiosInstance, collection, clientId, clientCode }) {
            try {
                const payload = { collection };
                if (clientId) {
                    payload.client = clientId;
                    payload.client_id = clientId;
                }
                if (clientCode) {
                    payload.code = clientCode;
                    payload.client_code = clientCode;
                }
                const response = await axiosInstance.post('/v2/ai/get-collection-ref-fields', payload);
                if (response.data && response.data.status === 'success') {
                    return response.data.data || {};
                }
                throw new Error(response.data?.message || 'Error fetching collection ref fields');
            } catch (error) {
                console.error('Error fetching collection ref fields:', error);
                const msg = error.response?.data?.message || error.message || 'Error fetching collection ref fields';
                throw new Error(msg);
            }
        }
    },
    getters: {
        // Prompts getters
        getPrompts: (state) => state.prompts,
        getPromptsLoading: (state) => state.promptsLoading,
        getPromptsError: (state) => state.promptsError,
        getPromptsByFeature: (state) => (featureName) => {
            const feature = state.prompts.find(f => f.feature === featureName);
            return feature ? feature.prompts : [];
        },
        getFeatureByName: (state) => (featureName) => {
            return state.prompts.find(f => f.feature === featureName);
        },
        // Prompt list getters
        getPromptsByType: (state) => state.promptsByType,
        getPromptsForType: (state) => (type) => {
            return state.promptsByType[type] || [];
        },
        getPromptListLoading: (state) => state.promptListLoading,
        isPromptListLoadingForType: (state) => (type) => {
            return state.promptListLoading[type] || false;
        },
        getPromptListError: (state) => state.promptListError,
        // Input schema getters
        getInputSchema: (state) => state.inputSchema,
        getInputSchemaLoading: (state) => state.inputSchemaLoading,
        getInputSchemaPreview: (state) => state.inputSchemaPreview,
        getInputSchemaPreviewLoading: (state) => state.inputSchemaPreviewLoading,
    },
}